var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('span',{staticStyle:{"color":"#666","font-size":"12px","font-style":"italic"}},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }